import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {Istanza, IstanzaPage, IstanzaResponse, IstanzaDTO} from "../models/istanza";
import {UserData} from "../models/user-data";
import {FormGroup} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class IstanzaService {
  url: string;
  portaleAmministrazioneURL: string;

  constructor(private httpClient: HttpClient) {
    this.url = "services/portaletributi/api/istanza";
    this.portaleAmministrazioneURL = "services/portaleamministrazione/api";
  }

  richiestaInizialeIstanza(istanzaDaRichiedere: Istanza): Observable<IstanzaDTO> {
    return this.httpClient.post<IstanzaDTO>(this.url + '/richiestaInizialeIstanza', {istanza: istanzaDaRichiedere})
  }

  richiestaSalvaIstanza(nuovaIstanza: IstanzaDTO, salvaPre?: boolean): Observable<any> {
    let urlPar = '/richiestaSalvaIstanza';
    if (salvaPre !== undefined) {
      urlPar += '?salvaPreferenze=' + String(salvaPre);
    }
    return this.httpClient.post(this.url + urlPar, nuovaIstanza)
  }


  istanzaPaginazione(istanzaPage: IstanzaPage): Observable<HttpResponse<Istanza[]>> {
    let url = this.url + '/search-frontoffice?';

    // Aggiungi i parametri all'URL solo se i valori non sono nulli
    if (istanzaPage.page !== '') {
      url += `page=${istanzaPage.page}&`;
    }
    if (istanzaPage.dataInizio !== '') {
      url += `dataIn=${istanzaPage.dataInizio}&`;
    }
    if (istanzaPage.dataFine !== '') {
      url += `dataFin=${istanzaPage.dataFine}&`;
    }
    if (istanzaPage.pagamento && istanzaPage.pagamento !== '') {
      url += `pagamento=${istanzaPage.pagamento}&`;
    }
    if (istanzaPage.numEl !== '') {
      url += `size=${istanzaPage.numEl}&`;
    }
    if (istanzaPage.istanza.stato?.codice !== undefined) {
      url += `stato=${istanzaPage.istanza.stato.codice}&`;
    }
    if (istanzaPage.id && istanzaPage.id !== 0) {
      url += `codice=${istanzaPage.id}&`;
    }
    if (istanzaPage.protocolloNumero) {
      url += `protocolloNumero=${istanzaPage.protocolloNumero}&`;
    }
    if (istanzaPage.protocolloAnno) {
      url += `protocolloAnno=${istanzaPage.protocolloAnno}&`;
    }

    // Rimuovi l'eventuale carattere "&" finale se l'URL ha parametri
    url = url + "appl=PNRR"

    return this.httpClient.get<Istanza[]>(url, {observe: 'response'});
  }


  getDatiIstanza(id: string): Observable<any> {
    return this.httpClient.get(this.url + '/getDatiIstanza-frontoffice/' + id);
  }

  getIstanzaPageAdmin(istanzaPage: IstanzaPage): Observable<IstanzaResponse> {
    return this.httpClient.post<IstanzaResponse>(this.url + '/getIstanzaOp', istanzaPage);
  }

  getRichiedentiByID(array: string[]): Observable<UserData[]> {
    return this.httpClient.post<UserData[]>(this.portaleAmministrazioneURL + "/pn-utente/listaUtentiLogin", array);
  }

  cambiaStatoAPI(cambiaStatoForm: FormGroup): Observable<any> {
    return this.httpClient.patch<any>(this.url + '/updateStato', cambiaStatoForm)
  }

  creaIntegrazioneAPI(integrazioneForm: FormGroup): Observable<any> {
    return this.httpClient.post<any>(this.url + '/crea-integrazione', integrazioneForm)
  }

  eliminaIstanza(id: string): Observable<any> {
    return this.httpClient.delete(this.url + `/elimina?valore=${id}`, {observe: "response", responseType: 'text'})
  }

  getIntegrazioniAPI(idIstanza: string | null | undefined): Observable<any> {
    return this.httpClient.get<any>(this.url + `/getIntegrazionifromIstanza?idIstanza=${String(idIstanza)}`);
  }

  validaIstanza(istanza: IstanzaDTO): Observable<any>{
    return this.httpClient.post(this.url + '/validaIstanza', istanza);
  }
}
